(function (){
    'use strict';

    angular
        .module('notificationsPlatform', [
            'ui.router',
            'ui.bootstrap',
            'ngDialog',
            'ui.select',
            'ngSanitize',
            'ngAnimate',
            'ui.footable',
        ]);
})();